<div class="link-horizontal">
    <a (click)="openVerticallyCentered(content)"
        class="btn btn-default btn-gradient text-white text-uppercase m-t-20 button-sound">Join
        us</a>
    <ng-template #content let-modal>
        <div class="modal-window">
            <div class="modal-header">
                <button aria-label="Close" (click)="closeModalWindow()" class="close" data-dismiss="modal"
                    type="button">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul class="nav nav-pills mb-4 justify-content-center" id="pills-tab-login" role="tablist">
                    <li class="nav-item">
                        <h2 aria-controls="pills-home" aria-selected="true" class="nav-link active" data-toggle="pill"
                            id="pills-home-tab">
                            Sending CV</h2>
                    </li>
                </ul>
                <div class="tab-content">
                    <div aria-labelledby="pills-home-tab" class="tab-pane fade show active" id="pills-home"
                        role="tabpanel">
                        <!-- cv send-form -->
                        <form class="d-flex flex-column align-items-center" #formSendCV [formGroup]="firstFormGroup"
                            (ngSubmit)="onSubmit(formSendCV)">
                            <div class="form-row">
                                <div class="col-md-6 p-r-15">
                                    <mat-form-field class="customize-input">
                                        <mat-label>Email <span class="text-danger">*</span>
                                        </mat-label>
                                        <input matInput formControlName="emailCtrl" type="email"
                                            placeholder="Ex. cs@example.com" autocomplete="off">
                                        <mat-icon class="font-primary" matSuffix>
                                            alternate_email
                                        </mat-icon>
                                        <mat-error *ngIf="firstFormGroup.controls['emailCtrl'].errors">
                                            Please enter a <strong>valid
                                                email</strong>
                                            address
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6 p-l-15">
                                    <mat-form-field class="customize-input">
                                        <mat-label>Your Name <span class="text-danger">*</span>
                                        </mat-label>
                                        <input matInput type="text" formControlName="nameCtrl"
                                            placeholder="Last name, First name" autocomplete="off">
                                        <mat-icon class="font-primary" matSuffix>
                                            perm_identity
                                        </mat-icon>
                                        <mat-error *ngIf="firstFormGroup.controls['nameCtrl'].errors">
                                            Name is
                                            <strong>required</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="form-group col-md-12 selectCV m-b-20">
                                    <input class="d-none" type="file" (change)="onFileSelect($event)" #hiddenfileinput>
                                    <button (click)="hiddenfileinput.click()" type="button" id="choose-cv"
                                        class="btn primary-btn btn-default"><i class="fa fa-file m-r-10"></i>Select
                                        CV</button>
                                </div>

                                <div class="col-md-12">
                                    <mat-form-field class="customize-input">
                                        <mat-label>Additional information
                                        </mat-label>
                                        <textarea matInput formControlName="aboutCtrl" #aboutCtrl
                                            placeholder="Address company, your position etc." maxlength="500"
                                            rows="5"></textarea>
                                        <mat-error *ngIf="firstFormGroup.controls['aboutCtrl'].errors">
                                            Max length is <strong>500
                                                symbols</strong>
                                        </mat-error>
                                        <mat-hint align="end">
                                            {{aboutCtrl.value.length}} /
                                            <strong>500</strong>
                                        </mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                            <button class="btn primary-btn btn-default text-uppercase width50 button-sound"
                                [disabled]="firstFormGroup.invalid">Send
                                CV</button>
                        </form>
                        <!-- end cv send form -->
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>